import { render, staticRenderFns } from "./EventSetupBasicNew.vue?vue&type=template&id=d07a63ac"
import script from "./EventSetupBasicNew.vue?vue&type=script&lang=js"
export * from "./EventSetupBasicNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports